import React from 'react'
import { getYear } from './constants'
import {
  Container,
  ContainerGrid,
  FooterCopyright,
  ButtonFooter,
  ContainerButtonFooter
} from './FooterDesktop.styles'
import { useTranslation } from 'i18n'
import { Cdn } from 'utils/assets'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import { useFeatureToggles } from 'utils/hooks/use-feature-toggles/useFeatureToggles'
import { useBiblionFooterSettings } from './FooterDesktop.hooks'

const ARVORE_PRIVACY_URL =
  'https://www.arvore.com.br/arvore-politica-de-privacidade-completo'

const FooterDesktop = () => {
  const { user } = useUserInfo()
  const { t } = useTranslation()
  const { featureToggles } = useFeatureToggles()
  const isBiblion = featureToggles?.biblionGeneral === true
  const biblionFooter = useBiblionFooterSettings(isBiblion)

  const ARVORE_HELP_PATH = user?.teacher
    ? 'https://central.arvore.com.br/central/educador?utm_source=plataforma&utm_medium=referral&utm_content=rodape_ajuda_educador&utm_campaign=central_2023'
    : 'https://central.arvore.com.br/central/estudante?utm_source=plataforma&utm_medium=referral&utm_content=rodape_ajuda_estudante&utm_campaign=central_2023'

  const ARVORE_TERMS_URL = Cdn.getAssetUrl(
    'Contrato/Termos_de_uso_e_contratacao_Arvore.pdf'
  )

  const privacyUrl = isBiblion
    ? biblionFooter.privacyPolicyUrl || ARVORE_PRIVACY_URL
    : ARVORE_PRIVACY_URL
  const termsUrl = isBiblion
    ? biblionFooter.termsUrl || ARVORE_TERMS_URL
    : ARVORE_TERMS_URL
  const helpUrl = isBiblion
    ? biblionFooter.helpUrl || ARVORE_HELP_PATH
    : ARVORE_HELP_PATH

  const copyrightText = isBiblion
    ? t('Copyright ©️ {{year}} BibliON. Todos os direitos reservados.', {
        year: getYear
      })
    : t('Copyright ©️ {{year}} Árvore. Todos os direitos reservados.', {
        year: getYear
      })

  return (
    <Container data-testid="appfooter">
      <ContainerGrid>
        <FooterCopyright>{copyrightText}</FooterCopyright>
        <ContainerButtonFooter data-test="appfooter-btns">
          <ButtonFooter
            href={privacyUrl}
            target="_blank"
            data-test="btn-privacity"
          >
            {t('Política de privacidade')}
          </ButtonFooter>
          <ButtonFooter href={termsUrl} target="_blank" data-test="btn-legal">
            {t('Termos de uso')}
          </ButtonFooter>
          <ButtonFooter href={helpUrl} target="_blank" data-test="btn-help">
            {t('Ajuda')}
          </ButtonFooter>
        </ContainerButtonFooter>
      </ContainerGrid>
    </Container>
  )
}

export default FooterDesktop
